import { Component, OnChanges, Input, HostListener } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { DonutChartModel } from './donut-chart.model';

@Component({
  selector: 'app-donut-chart',
  templateUrl: './donut-chart.component.html',
  styleUrls: ['./donut-chart.component.scss']
})
export class DonutChartComponent implements OnChanges {
  public radius;
  public strokeWidth;
  public width;
  public height;
  public cx;
  public cy;
  public totalValue: number;
  // foreignObject position coordinates
  public x;
  public y;
  public fWidth;
  public fHeight;
  private seperatorWidth = 1;

  @Input('stroke_width') stroke_width = 20; // '30';
  @Input('r') r = 90; // 135;
  @Input('data') data: Array<DonutChartModel>;
  @Input('label') label: string;
  @Input('error') error = false;

  constructor() { }
  ngOnChanges(changes) {
    const square = (Number(this.r) * 2) + Number(this.stroke_width);
    this.width = square + 'px';
    this.height = square + 'px';
    this.cx = square / 2;
    this.cy = square / 2;
    this.fWidth = square - ((Number(this.stroke_width) + 10) * 2);
    this.fHeight = this.y = square / 3;
    this.x = (Number(this.stroke_width)) + 10;
    this.totalValue = 0;
    this.data.forEach((val) => {
      this.totalValue += val.value;
    });
  }

  calculateStrokes(value, index) {
    let dashArrayElm1, dashArrayElm2, dashOffset, buffer = 0;
    const circumference = 2 * 3.14 * this.r;
    const initialOffset = circumference / 4;

    // Sum all precede arc values(%)
    for (let i = 0; i < index; i++) {
      buffer = buffer + (this.data[i].value / this.totalValue);
    }
    buffer = circumference * buffer;

    dashArrayElm1 = circumference * value / this.totalValue;
    dashArrayElm2 = circumference - dashArrayElm1;
    dashOffset = circumference - buffer + initialOffset;
    return {
      'stroke_dash_array': (dashArrayElm1 - this.seperatorWidth) + ' ' + (dashArrayElm2 + this.seperatorWidth),
      'stroke_dash_offset': index === 0 ? initialOffset : dashOffset
    };

  }


}
